export default "__VITE_ASSET__F1MBzQ$f__"